import {
  ALL_PERMISSIONS,
  PERMISSIONS_WITH_LABEL_KEY,
} from '@conversed/shared/src/central/constants/permissions';
import { useMemo } from 'react';
import { useMainSelector } from '../../useMainSelector';

export const useRole = () => {
  const {
    settings: { roles, company },
  } = useMainSelector();

  const assignableRoles = useMemo(() => {
    return company?.assignableRoles || [];
  }, [company]);

  const assignableClientRoles = useMemo(() => {
    return assignableRoles.filter((role) => role.type === 'client');
  }, [assignableRoles]);

  return {
    roles,
    permissions: ALL_PERMISSIONS,
    permissionsWithLabelKey: PERMISSIONS_WITH_LABEL_KEY,
    assignableRoles,
    assignableClientRoles,
  };
};

export default useRole;
